import RequestList from "./Request/RequestList";
import ProjectList from "./Request/ProjectList";
import RequestCreation from "./Request/RequestCreation";
import RequestDetails from "./Request/RequestDetails";
import RequestCreationReducer from "./Request/RequestCreationState/RequestCreationReducer";
import Home from "./HomePage/Home";
import HomeProject from "./HomePage/HomeProject";
import HomeService from "./HomePage/HomeService";
import MembersPage from "./HomePage/MembersPage";
import UserDetails from "./Component/UserDetails";
import RequestSupport from "./Request/RequestSupport";
import ProjectsPage from "./HomePage/ProjectsPage";

import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default function Router() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="home" element={<Home />} />
        <Route path="home_project" element={<ProjectsPage />} />
        <Route path="home_project/:page" element={<HomeProject />} />
        <Route path="home_service/:page" element={<HomeService />} />
        <Route path="home_member" element={<MembersPage />} />
        <Route path="project_list" element={<ProjectList />} />
        <Route path="request_list" element={<RequestList />} />
        <Route path="support" element={<RequestSupport />} />
        <Route
          path="request_creation"
          element={
            <RequestCreationReducer>
              <RequestCreation />
            </RequestCreationReducer>
          }
        />
        <Route path="request_details" element={<RequestDetails />} />
        <Route path="user_details" element={<UserDetails />} />
      </Routes>
    </BrowserRouter>
  );
}
